import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "check",
  "use": "check-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"check\"><g fill=\"none\" fill-rule=\"evenodd\"><path /><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M19.3 6.3L9 16.6l-4.3-4.3a1 1 0 00-1.4 0 1 1 0 000 1.4l5 5a1 1 0 001.4 0l11-11c.4-.4.4-1 0-1.4a1 1 0 00-1.4 0z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol